import { withHandlers, compose } from 'recompose'
import { connect } from 'react-redux'
import { servicesCheckboxClick } from 'actions/thirdParty'
import CheckboxList from 'components/common/FormElements/CheckboxList/CheckboxList'
import Theme from 'components/common/Theme/Theme'
import { googleAnalyticProductAddToCartServiceSelect } from 'actions/googleAnalytic'
import { getCurrentStore } from 'selectors/getCurrentStore'
import { QUICK_APPOINTMENT_SERVICE_CHECKBOX_LIST_SOURCE } from 'constant'

const mapStateToProps = (state) => {
  const { storeNumber } = getCurrentStore(state) || {}

  return {
    storeNumber
  }
}

const withControlHandlers = withHandlers({
  handleChange: ({
    onChange,
    value,
    placeholder,
    servicesCheckboxClick,
    googleAnalyticProductAddToCartServiceSelect,
    storeNumber
  }) => (
    checkboxValue,
    checked,
    revenue,
    label = ''
  ) => {
    const newValue =
      checked ?
        [...value, checkboxValue].filter(value => value !== placeholder) :
        value.filter(value => value !== checkboxValue)
    const defaultQuantity = 1
    const GTMServiceSelectPayload = {
      data: {
        name: label,
        id: checkboxValue,
        category: 'Quick Appointment',
        quantity: defaultQuantity,
        dlvStoreNumber: storeNumber
      }
    }

    checked && googleAnalyticProductAddToCartServiceSelect({
      ...GTMServiceSelectPayload,
      ...QUICK_APPOINTMENT_SERVICE_CHECKBOX_LIST_SOURCE
    })
    onChange(newValue)
    servicesCheckboxClick({ revenue })
  },
  handleReset: ({ onChange }) => () => onChange([])
})

const withEnterKeydownHandler = withHandlers({
  onKeyDown: () => e => e.keyCode === Theme.keyCode.ENTER && e.preventDefault()
})

export default compose(
  connect(mapStateToProps, { servicesCheckboxClick, googleAnalyticProductAddToCartServiceSelect }),
  withControlHandlers,
  withEnterKeydownHandler
)(CheckboxList)
